import { useQuery } from "@tanstack/react-query"
import { DailyCallReportFunction } from "./DailyCallReportRepo"

export const UseDailyCallReport=({param={},enable}:{param:any,enable:boolean})=>{
    return useQuery({
        queryKey:['DAILY_CALL_REPORT',param],
        queryFn:()=>DailyCallReportFunction(param),
        enabled:enable,
        retry:false,
    })
}
